import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
  SuiModalService,
} from '@richardlt/ng2-semantic-ui';
import { PaymentReviewModal } from '../index';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { AppFilter } from '../../../../shared/models/filter';
import { ContractorService } from '../../services/contractor.service';
import { OrganizationBidderService } from '../../services/organization-bidders.service';
import { environment } from 'src/environments/environment';
interface IProjectNewModalContext {
  extraData?: any;
  title?: string;
}
@Component({
  selector: 'tender-payment-new-modal',
  templateUrl: './tender-payment.component.html',
  styleUrls: ['./tender-payment.component.scss'],
})
export class TenderPaymentModalComponent implements OnInit, OnDestroy {
  procurementType: any = [];

  public mode: DatepickerMode = 'year';
  public maxDate = new Date();
  private unsubscribe$: Subject<void> = new Subject<void>();
  formSubmitAttempt: boolean;
  success: any;
  error: any;
  pendingArr = [];
  data: any;
  createProcurementItem: FormGroup;
  procurementCycleParams: AppFilter;
  currentPage = 1;
  public maxSize = 5;
  total = 5;
  optionsvalues = [];
  cycleId;
  extraData = this.modal.context.extraData;
  disabled = true;
  paymentDetails;
  eServicesURL = environment.ESERVICES_URL;
  token;
  constructor(
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    public modal: SuiModal<IProjectNewModalContext, void, void>,
    private router: Router,
    private service: ContractorService,
    private modalService: SuiModalService,
    private serviceOB: OrganizationBidderService
  ) {
    this.createProcurementItem = fb.group({
      description: ['', Validators.required],
      payerAddress: ['', Validators.required],
      payerName: ['', Validators.required],
      amount: [this.extraData.lot.amount, Validators.required],
      payerPhone: ['', Validators.required],
      payerEmail: ['', Validators.required],
      lotId: [this.extraData.lotId],
      biddingStageId: [this.extraData.biddingStageId],
      bidderId: [this.extraData.bidderId],
    });

    this.createProcurementItem.controls['amount'].disable();

    this.token = JSON.parse(localStorage.getItem('userData'))
      ? JSON.parse(localStorage.getItem('userData'))['token']
      : null;
  }
  isFieldValid(field: string) {
    return (
      (!this.createProcurementItem.get(field).valid &&
        this.createProcurementItem.get(field).touched) ||
      (this.createProcurementItem.get(field).untouched &&
        this.formSubmitAttempt)
    );
  }
  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }
  displayFormCss(field: string) {
    return {
      pending: field,
    };
  }
  save() {}
  nullify() {
    this.success = null;
    this.error = null;
  }
  ngOnInit() {
    this.document.body.classList.add('panel');
  }
  ngOnDestroy(): void {
    // this.document.body.classList.remove('panel');
  }
  onSubmit() {}

  callStarted() {
    this.pendingArr.push(true);
  }

  callCompleted() {
    this.pendingArr.pop();
  }

  tenderPayment() {
    // route to eservices and pass token
    // window.location.href = `${this.eServicesURL}/redirect?token=${this.token}&route=`;

    this.callStarted();
    let body = this.createProcurementItem.value;
    body.currencyId = 'naira';
    this.service
      .createTenderPayment({
        lotId: this.extraData.lotId,
        biddingStageId: this.extraData.biddingStageId,
        bidderId: this.extraData.bidderId,
        body: body,
      })
      .subscribe(
        (res) => {
          this.success = 'Tender Payment Successful';
          this.callCompleted();
          res.additionalDetails = JSON.parse(res.additionalDetails);
          this.paymentDetails = res;
          console.log(this.paymentDetails);
          console.log(res, 'payment');
          this.tenderPaymentPreview();
          setTimeout(() => {
            this.modal.approve();
          }, 2000);
        },
        (error) => {
          this.error = error.error ? error.error : error;
          this.callCompleted();
        }
      );
  }

  tenderPaymentPreview() {
    this.modalService
      .open(
        new PaymentReviewModal(
          'Make Tender Fee Payment',
          this.paymentDetails,
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        setTimeout(() => {
          this.modal.approve();
        }, 2000);
      })
      .onDeny(() => {});
  }
}

export class TenderPaymentModal extends ComponentModalConfig<
  IProjectNewModalContext,
  void,
  void
> {
  constructor(
    title: string,
    extraData: any,
    size: ModalSize = ModalSize.Small
  ) {
    super(TenderPaymentModalComponent, { title, extraData });
    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
